import { Typography } from "@mui/material"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import { Title } from "react-admin"

export const Dashboard = () => (
  <Card sx={{ mt: 2 }}>
    <Title title="" />
    <Typography variant="h5" component="div">
      MYNE Admin
    </Typography>
    <CardContent>...</CardContent>
  </Card>
)
